import type { AppShell } from "@/App"
import { ModuleCatalogTab, type CatalogConfig } from "@/components/mappings/ModuleCatalogTab"

/**
 * Catálogo AC (app-owned) nos Mapeamentos — mesma mecânica do solar
 * (ModuleCatalogTab). Preço = Excel nas linhas do seed; custo do Odoo nas que
 * se adicionam pela pesquisa.
 */
const AC_CONFIG: CatalogConfig = {
  kind: "ac",
  intro:
    "Catálogo do simulador de Ar Condicionado. Pesquise para adicionar um produto do CRM ao grupo; a referência liga cada linha ao artigo do Odoo.",
  roles: [
    { value: "ac_monosplit", label: "Monosplit (kit)" },
    { value: "ac_indoor_mono_multi", label: "Interior mono/multi" },
    { value: "ac_indoor_multi", label: "Interior multi" },
    { value: "ac_indoor_mono", label: "Interior mono" },
    { value: "ac_outdoor_mono", label: "Exterior mono" },
    { value: "ac_multisplit_outdoor", label: "Exterior multisplit" },
    { value: "installation", label: "Instalação" },
    { value: "labour", label: "Mão de obra" },
  ],
  fieldsFor: (role) => {
    if (role === "installation" || role === "labour") return []
    return [
      { key: "gama", label: "Gama", type: "text" },
      { key: "btu", label: "BTU", type: "int" },
      { key: "cooling_kw", label: "kW", type: "num" },
      { key: "n_ports", label: "Portas", type: "int" },
    ]
  },
  hasBrand: (role) => role !== "installation" && role !== "labour",
}

export function AcCatalogTab({
  shell,
  onOpenProduct,
}: {
  shell: AppShell | null
  onOpenProduct?: (productId: number) => void
}) {
  return <ModuleCatalogTab shell={shell} config={AC_CONFIG} onOpenProduct={onOpenProduct} />
}
